import React from 'react';

import ReactDOM from 'react-dom';
import {
	Button,
	Collapse,
	CollapseItem
} from 'element-react';

 

import KeeVue from '../base/KeeVue.js'



import $ from 'jquery';


export default class FsResizeBtn extends KeeVue {
	constructor(props) {
		super(props);

		this.state = {
			moveDirect: '',
			point: {
							x: 0,
							y: 0,
							w: 0,
							h: 0,
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
						},
						currentScale: 100,
						designerContentStyle: {
							'transform': 'scale(1)',
							'transformOrigin': '0px 0px',
							'WebkitTransform': 'scale(1)',
							'WebkitTransformOrigin': '0px 0px'
						},
		}

	}

	componentWillMount() {}
	
	renderComponentResize=()=>{
		
		var points = {
						top: {
							left: "50%",
							top: "-5px",
							cursor: "n-resize",
						},
						left: {
							left: "-5px",
							top: "50%",
							cursor: "w-resize",
						},
						right: {
							right: "-5px",
							top: "50%",
							cursor: "w-resize",
						},
		
						bottom: {
							bottom: "-5px",
							left: "50%",
							cursor: "n-resize",
						},
					}
					
		return <div>
		<div className={`resize-border-top`} style={this.state.designerContentStyle}></div>
		<div className={`resize-border-left`} style={this.state.designerContentStyle}></div>
		<div className={`resize-border-right`} style={this.state.designerContentStyle}></div>
		<div className={`resize-border-bottom`} style={this.state.designerContentStyle}></div>
		</div>
					
		
	}

	renderItem=(item,index)=>{
		if(item.isSelected&&item.style.position==='absolute')
		{
			var childDom = null ;
			if(item.child&&item.child.length>0)
			{
				childDom = item.child.map((item2,index2)=>{
					return this.renderItem(item2,index2);
				})
			}
			return <div key={index}><FsResizeBtn component={item}></FsResizeBtn>
			{childDom}</div>
		}
	}
	

	render() {
		// if(this.props.component.isSystem)
		// {
		// 	return <div></div>
		// }
		return <div    >
		{
			this.props.component.style.position=='absolute'&&this.props.component.name!='fs-layout'?<div 
			 tag="resizer" className={`pointer-events-none`}
			 style={{position: 'absolute',
					left: 0,
					top: 0, 
					pointerEvents: "none", 
					width: '0',
					height: '0'}}></div>
			:
			<div tag="resizer"  
			 style={{position: 'absolute',
					left: 0,
					top: 0, 
					right:0,
					bottom:0,
					pointerEvents: "none", 
					width: '100%',
					height: '100%'}}>
					
					{this.renderComponentResize()}
					
					</div>
			 
		}
		</div>;
	}
}
